import React, { useEffect, useState } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { ActionIcon, Badge, Box, Button, Drawer, Flex, Group, Menu, Modal, Pagination, Select, SimpleGrid, Text, TextInput, SegmentedControl, Center, Table, Image, NumberFormatter } from '@mantine/core'
import { IconDots, IconPlus, IconList, IconTable } from '@tabler/icons-react'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import ProductCard from '../../../../component/pages/Product/ProductCard'
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks'
import { addSubProduct, cloneProduct, deleteProduct, getAllProductsList } from '../../../../services/products'
import { useNavigate } from 'react-router-dom'
import FormFilterCategoryProduct from '../../../../component/pages/Product/FormFilterCategoryProduct'
import FormFilterProduct from '../../../../component/pages/Product/FormFilterProducts'
import FormAddProductUrl from '../../../../component/pages/Product/FormAddProductUrl'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import { completedLoadingNotification, failedLoadingNotification, loadingNotification } from '../../../../component/ui/Notifications'
import { modalGeneralConfirmation } from '../../../../component/ui/Prompt/modalGeneralConfirmation'
import dayjs from 'dayjs'
import NoImage from '../../../../assets/img/images/no-images.png'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  'visibility': true,
  'sort': '-updated_at',
  'filter[title][like]': '',
  'include': 'supplier,creator,warehouses,brand,statuses,children',
  'filter[parent_id][null]': true,
}

const AllListProduct = () => {
  const navigate = useNavigate()
  const [filterStatus, setFilterStatus] = useState('all')
  const [productList, setProductList] = useState([])
  const [totalProduct, setTotalProduct] = useState(0)
  const [loading, setLoading] = useState(true)
  const [totalEmptyProduct, setTotalEmptyProduct] = useState(0)
  const [totalReviewProduct, setTotalReviewProduct] = useState(0)

  const [paramsProduct, setParamsProduct] = useState(defaultParams)

  // Layout View Switch (card / table)
  const [selectedLayout, setSelectedLayout] = useState('card')

  // Selected Product IDs for bulk edit (using useLocalStorage to share list with Detail page)
  const [selectedBulkIds, setSelectedBulkIds] = useLocalStorage({
    key: 'bulk-edit-product-ids',
    defaultValue: []
  })

  const handleToggleBulkSelection = (id) => {
    setSelectedBulkIds((prev) => {
      const numericId = Number(id)
      if (prev.includes(numericId)) {
        return prev.filter((item) => item !== numericId)
      } else {
        return [...prev, numericId]
      }
    })
  }

  // modal
  const [modalFilterCategoryProduct, setModalFilterCategoryProduct] = useState(false)
  const [modalFilterProduct, setModalFilterProduct] = useState(false)

  // sync url
  const [modalAddProductUrl, setModalAddProductUrl] = useState(false)

  const dispatch = useDispatch()

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Product',
      route: null
    },
    {
      label: 'All',
      route: null
    },
  ]

  const defaultSortFilter = [
    {
      value: '-updated_at',
      label: 'Sort by latest updated'
    },
    {
      value: '-created_at',
      label: 'Sort by latest created'
    },
  ]

  const defaultFilter = [
    {
      value: 'all',
      label: 'All'
    },
    {
      value: 'live',
      label: 'Live'
    },
    {
      value: 'out_of_stock',
      label: `Out of Stock (${totalEmptyProduct})`
    },
    {
      value: 'retail',
      label: 'Retail'
    },
    {
      value: 'wholesale',
      label: 'Wholesale'
    },
    {
      value: '57', // statuses id
      label: `In Review (${totalReviewProduct})`
    },
    {
      value: '59', // statuses id
      label: 'Rejected'
    },
    {
      value: '58', // statuses id
      label: 'Draft'
    },
    {
      value: '56', // statuses id
      label: 'Pass'
    },
    {
      value: 'promo_deals',
      label: 'Promo Deals'
    },
    {
      value: 'product_import_by_url',
      label: 'Product Import By URL'
    },
  ]

  const handleGetAllProduct = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllProductsList(paramsProduct)
      if (response.success) {
        const { data, included, meta } = response
        const countData = meta.pagination.total

        const { brand, supplier, creator, warehouses, statuses } = included

        const remap = data.map((product) => {
          const { attributes, relationships } = product

          const getBrandName = () => {
            return brand[relationships?.brand?.id]?.attributes?.name || '-'
          }
          const getSupplierName = () => {
            return supplier[relationships?.supplier?.id]?.attributes?.name || '-'
          }
          const getCreatorName = () => {
            return creator[relationships?.creator?.id]?.attributes?.name || '-'
          }
          const getWarehouseName = () => {
            return warehouses[relationships?.warehouses[0]?.id]?.attributes?.name || '-'
          }
          const getStatusName = () => {
            return statuses[relationships?.statuses[0]?.id]?.attributes?.name || '-'
          }
          const getSubProductsCount = () => {
            return relationships?.children.length || 0
          }

          return {
            id: attributes.id,
            title: attributes.title,
            originalCurrency: attributes.original_currency,
            regularPrice: attributes.regular_price,
            salePrice: attributes.sale_price,
            resellerPrice: attributes.reseller_price,
            createdAt: attributes.created_at,
            updatedAt: attributes.updated_at,
            image: attributes.image,
            brands: getBrandName(),
            warehouse: getWarehouseName(),
            creator: getCreatorName(),
            supplier: getSupplierName(),
            status: getStatusName(),
            weight: attributes.weight,
            weightUnit: attributes.weight_unit,
            notShowInCatalog: attributes.not_show_in_catalog,
            visibility: attributes.visibility,
            subProductCount: getSubProductsCount(),
          }
        })

        setProductList(remap)
        setTotalProduct(countData)
      } else {
        setProductList([])
        setTotalProduct(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 500)

  const handleGetEmptyProduct = async () => {
    const params = {
      'filter[quantity]': 0,
      sort: '-id',
      include: 'supplier,creator,warehouses,brand,statuses',
    }
    try {
      const response = await getAllProductsList(params)
      if (response.success) {
        const { meta } = response
        const countData = meta.pagination.total
        setTotalEmptyProduct(countData)
      } else {
        setTotalEmptyProduct(0)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetReviewProduct = async () => {
    const params = {
      'statuses.id': 57,
      sort: '-id',
      include: 'supplier,creator,warehouses,brand,statuses',
    }
    try {
      const response = await getAllProductsList(params)
      if (response.success) {
        const { meta } = response
        const countData = meta.pagination.total
        setTotalReviewProduct(countData)
      } else {
        setTotalReviewProduct(0)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // clone product
  const handleCloneProduct = async (productId) => {
    loadingNotification('clone-product', 'Cloning Product', 'Please wait while we clone the product...')
    const payload = {
      id: productId,
    }
    try {
      const response = await cloneProduct(payload)
      if (response.success) {
        completedLoadingNotification('clone-product', 'Product Cloned', 'The product has been cloned successfully.')
        handleGetAllProduct()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      failedLoadingNotification('clone-product', 'Failed to Clone Product', `${errorMessage ? errorMessage : 'There was an error cloning the product. Please try again.'}`)
    }
  }

  // Sub Products
  const handleAddSubProduct = async (productId) => {
    loadingNotification('add-sub-product', 'Creating Sub Product', 'Please wait while we create the sub product...')
    try {
      const response = await addSubProduct(productId)
      if (response.success) {
        completedLoadingNotification('add-sub-product', 'Sub Product Created', 'The sub product has been created successfully.')
        handleGetAllProduct()
      }
    } catch (error) {
      failedLoadingNotification('add-sub-product', 'Failed to Create Sub Product', 'There was an error creating the sub product. Please try again.')
    }
  }

  // actions
  const actions = {
    edit: (val) => {
      navigate(`/product/${val.id}`)
    },
    clone: (val) => {
      modalGeneralConfirmation({
        useCustomImage: true,
        image: val.image,
        label: 'Are you sure you want to clone this product?',
        name: val.title,
        description: 'This action will create a new product with the prefix "clone_" added to the Product Name, Slug, and SKU, which you will need to adjust later.',
        textButton: 'Clone Product',
        onConfirm: () => handleCloneProduct(val.id)
      })
    },
    addSubProduct: (val) => {
      modalGeneralConfirmation({
        useCustomImage: true,
        image: val.image,
        label: 'Are you sure you want to create Sub-Product from this product?',
        name: val.title,
        description: 'This action will create a sub-product with the prefix "clone_" added to the Product Name, Slug, and SKU, which you will need to adjust later.',
        textButton: 'Create Sub-Product',
        onConfirm: () => handleAddSubProduct(val.id)
      })
    },
    seeSubProduct: (val) => {
      navigate(`/product/${val.id}?tab=branch`)
    },
    delete: (val) => {
      modalDeleteData('Product', val.id, val.title, deleteProduct, handleGetAllProduct)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }


  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetAllProduct()
    handleGetEmptyProduct()
    handleGetReviewProduct()
    // eslint-disable-next-line
  }, [paramsProduct])

  const resetParams = () => {
    const {
      'filter[quantity]': quantity,
      'filter[tags.id][is]': tags,
      'filter[source_id][in]': sourceId,
      'filter[original_source_url][not]': sourceUrlNot,
      'statuses.id': statuses,
      promo,
      ...newObj
    } = paramsProduct
    setParamsProduct(() => newObj)
  }

  useEffect(() => {
    resetParams()
    if (filterStatus === 'out_of_stock') {
      handleChangeFilter('filter[quantity]', 0)
    } else if (filterStatus === 'retail') {
      handleChangeFilter('filter[tags.id][is]', '2')
    } else if (filterStatus === 'wholesale') {
      handleChangeFilter('filter[tags.id][is]', '1')
    } else if (filterStatus === 'promo_deals') {
      handleChangeFilter('promo', true)
    } else if (filterStatus === 'product_import_by_url') {
      handleChangeFilter('filter[source_id][in]', '1,6,7,8,9,10,11')
      handleChangeFilter('filter[original_source_url][not]', 'null')
    } else if (filterStatus !== 'all' && filterStatus !== 'live') {
      handleChangeFilter('statuses.id', filterStatus)
    }
    // eslint-disable-next-line
  }, [filterStatus])

  const handleChangeFilter = (name, val) => {
    setParamsProduct((oldVal) => ({ ...oldVal, [name]: val }))
  }

  const handleApplyFilter = (params) => {
    setParamsProduct((oldVal) => ({ ...oldVal, ...params }))
  }

  const clearFilter = () => {
    setFilterStatus('all')
    setParamsProduct(defaultParams)
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParamsProduct((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const renderFilterInfo = (parameter) => {
    if (
      parameter['filter[title][like]']
      || parameter['filter[categories.id][is]']
      || parameter['filter[original_title][like]']
      || parameter['filter[ali_sku][like]']
      || parameter['filter[id][is]']
      || parameter['filter[country_id][is]']
      || parameter['filter[warehouses.id][like]']
      || parameter['filter[tags.id][is]']
      || parameter['filter[brand_id][is]']
      || parameter['filter[quantity]'] === 0
      || parameter['filter[country_id][null]']
      || parameter['imported']
      || parameter['filter[merchant][null]'] === false
      || parameter['filter[merchant][null]'] === true
      || parameter['filter[weight][is]'] === 0
      || parameter['filter[supplier.name][like]']
    ) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[title][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Title : {parameter['filter[title][like]']}</Badge> : ''}
            {parameter['filter[original_title][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Original Title : {parameter['filter[original_title][like]']}</Badge> : ''}
            {parameter['filter[ali_sku][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>ALI-SKU : {parameter['filter[ali_sku][like]']}</Badge> : ''}
            {parameter['filter[id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Product Id : {parameter['filter[id][is]']}</Badge> : ''}
            {parameter['filter[country_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Country : {parameter['filter[country_id][is]']}</Badge> : ''}
            {parameter['filter[warehouses.id][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Warehouse : {parameter['filter[warehouses.id][like]']}</Badge> : ''}
            {parameter['filter[categories.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Category : {parameter['filter[categories.id][is]']}</Badge> : ''}
            {parameter['filter[tags.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Tags / Label : {parameter['filter[tags.id][is]']}</Badge> : ''}
            {parameter['filter[brand_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Brand : {parameter['filter[brand_id][is]']}</Badge> : ''}
            {parameter['filter[quantity]'] === 0 ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Out of Stock Product</Badge> : ''}
            {parameter['filter[country_id][null]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Not Country</Badge> : ''}
            {parameter['imported'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Attach to My Product</Badge> : ''}
            {parameter['filter[merchant][null]'] === false ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Add by User</Badge> : ''}
            {parameter['filter[merchant][null]'] === true ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Add by Admin</Badge> : ''}
            {parameter['filter[weight][is]'] === 0 ? <Badge variant="light" color="black" tt='capitalize' fw='500'>No Weight Product</Badge> : ''}
            {parameter['filter[supplier.name][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Supplier : {parameter['filter[supplier.name][like]']}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setModalFilterProduct(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => clearFilter()}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  const remapProductList = (dataProduct) => {
    const remapData = dataProduct.map((product, index) => {
      return (
        <Box key={index} onClick={() => navigate(`/product/${product.id}`)}>
          <ProductCard dataProduct={product} handleAction={handleAction} />
        </Box>
      )
    })
    return remapData
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>All Product List</Text>
            <Group gap='sm' align='center'>
              <SegmentedControl
                withItemsBorders={false}
                value={selectedLayout}
                onChange={setSelectedLayout}
                data={[
                  { 
                    label: (
                      <Center style={{ gap: 6 }}>
                        <IconList size={14} />
                        <span>Card</span>
                      </Center>
                    ), 
                    value: 'card' 
                  },
                  { 
                    label: (
                      <Center style={{ gap: 6 }}>
                        <IconTable size={14} />
                        <span>Table</span>
                      </Center>
                    ),
                    value: 'table' 
                  },
                ]}
                size='xs'
                radius='sm'
                color='red'
              />
              <TextInput
                value={paramsProduct['filter[title][like]']}
                placeholder='Search by title'
                onChange={(val) => {
                  handleChangeFilter('filter[title][like]', val.target.value)
                  handleChangePage(1)
                }}
                size='xs'
              />
              <Select
                placeholder='Filter by Status'
                data={defaultFilter}
                size='xs'
                value={filterStatus}
                onChange={(val) => setFilterStatus(val)}
                defaultValue={'all'}
                w={140}
              />
              <Select
                placeholder='Filter by Sort by'
                data={defaultSortFilter}
                size='xs'
                value={paramsProduct['sort']}
                onChange={(val) => handleChangeFilter('sort', val)}
              />

              <Button size='xs' variant="outline" onClick={() => setModalFilterProduct(true)}>Filter</Button>
              <Button size='xs' variant="outline" onClick={() => setModalFilterCategoryProduct(true)}>Filter by Category</Button>

              <Menu shadow="md" width={240} trigger="hover" openDelay={100}>
                <Menu.Target>
                  <Button size='xs' leftSection={<IconPlus size={14} />}>Add New Product</Button>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item leftSection={<IconPlus size={14} />} onClick={() => navigate('/product/add')}>
                    Add Product Manually
                  </Menu.Item>
                  <Menu.Item leftSection={<IconPlus size={14} />} onClick={() => setModalAddProductUrl(true)}>
                    Add Product with URL
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>

              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon variant="outline" aria-label="Others">
                    <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item disabled>
                    Other tools
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Group>
          </Flex>
        </Box>

        <Box my={30}>
          {renderFilterInfo(paramsProduct)}
          <Group my={10} gap='xs'>
            <Text fz={12}>Total Product Found: </Text>
            <Text fz={12} fw='bold'>{totalProduct} Products </Text>
          </Group>
          {loading
            ? <LoadingData />
            : productList.length > 0
              ? selectedLayout === 'card'
                ? <SimpleGrid cols={{ base: 2, sm: 3, md: 4, lg: 5 }} spacing="lg" verticalSpacing="lg">
                  {remapProductList(productList)}
                </SimpleGrid>
                : <Table.ScrollContainer minWidth={800}>
                  <Table verticalSpacing="xs" striped highlightOnHover>
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th>Product Name</Table.Th>
                        <Table.Th>Supplier</Table.Th>
                        <Table.Th>Retail Price</Table.Th>
                        <Table.Th>Dropship Price</Table.Th>
                        <Table.Th>Discount Price</Table.Th>
                        <Table.Th>Date Created</Table.Th>
                        <Table.Th>Date Updated</Table.Th>
                        <Table.Th>Catalog Visible</Table.Th>
                        <Table.Th style={{ width: 160 }}>Action</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {productList.map((product) => {
                        const isSelected = selectedBulkIds.includes(product.id)
                        const isLive = !product.notShowInCatalog && product.visibility
                        const isHiddenFromCatalog = product.notShowInCatalog && product.visibility
                        const isHiddenFromApp = !product.visibility

                        return (
                          <Table.Tr key={product.id}>
                            <Table.Td>
                              <Flex gap="sm" align="center">
                                <Image
                                  src={product.image || NoImage}
                                  w={40}
                                  h={40}
                                  radius="sm"
                                  fallbackSrc={NoImage}
                                />
                                <Text
                                  size="sm"
                                  fw={500}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => navigate(`/product/${product.id}`)}
                                  lineClamp={2}
                                >
                                  {product.title}
                                </Text>
                              </Flex>
                            </Table.Td>
                            <Table.Td>
                              <Text size="sm">{product.supplier}</Text>
                            </Table.Td>
                            <Table.Td>
                              <Text size="sm" fw={500}>
                                <NumberFormatter
                                  prefix={`${product.originalCurrency} `}
                                  thousandSeparator=","
                                  decimalSeparator="."
                                  decimalScale={2}
                                  fixedDecimalScale
                                  value={product.regularPrice}
                                />
                              </Text>
                            </Table.Td>
                            <Table.Td>
                              <Text size="sm" fw={500}>
                                <NumberFormatter
                                  prefix={`${product.originalCurrency} `}
                                  thousandSeparator=","
                                  decimalSeparator="."
                                  decimalScale={2}
                                  fixedDecimalScale
                                  value={product.resellerPrice}
                                />
                              </Text>
                            </Table.Td>
                            <Table.Td>
                              <Text size="sm" fw={500}>
                                <NumberFormatter
                                  prefix={`${product.originalCurrency} `}
                                  thousandSeparator=","
                                  decimalSeparator="."
                                  decimalScale={2}
                                  fixedDecimalScale
                                  value={product.salePrice}
                                />
                              </Text>
                            </Table.Td>
                            <Table.Td>
                              <Text size="xs">
                                {product.createdAt ? dayjs(product.createdAt).format('DD/MM/YYYY HH:mm:ss') : '-'}
                              </Text>
                            </Table.Td>
                            <Table.Td>
                              <Text size="xs">
                                {product.updatedAt ? dayjs(product.updatedAt).format('DD/MM/YYYY HH:mm:ss') : '-'}
                              </Text>
                            </Table.Td>
                            <Table.Td>
                              {isLive && (
                                <Badge color="green" variant="light">
                                  Visible
                                </Badge>
                              )}
                              {isHiddenFromCatalog && (
                                <Badge color="yellow" variant="light">
                                  Hidden in Catalog
                                </Badge>
                              )}
                              {isHiddenFromApp && (
                                <Badge color="gray" variant="light">
                                  Hidden
                                </Badge>
                              )}
                            </Table.Td>
                            <Table.Td>
                              <Button
                                size="xs"
                                variant={isSelected ? 'filled' : 'outline'}
                                color={isSelected ? 'red' : 'blue'}
                                onClick={() => handleToggleBulkSelection(product.id)}
                              >
                                {isSelected ? 'Remove' : 'Add to Bulk'}
                              </Button>
                            </Table.Td>
                          </Table.Tr>
                        )
                      })}
                    </Table.Tbody>
                  </Table>
                </Table.ScrollContainer>
              : <NoData />
          }
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalProduct / paramsProduct['page[limit]']) || 0} />
        </Flex>
      </Box>

      {/** filter product */}
      <Drawer position='right' title='Filter Product' opened={modalFilterProduct} onClose={() => setModalFilterProduct(false)}>
        <FormFilterProduct paramsProducts={paramsProduct} applyFilter={handleApplyFilter} onClose={() => setModalFilterProduct()} />
      </Drawer>

      <Modal size='xl' opened={modalFilterCategoryProduct} onClose={() => setModalFilterCategoryProduct(false)} title="Filter By Category">
        <FormFilterCategoryProduct
          setCategory={(val) => handleChangeFilter('filter[categories.id][is]', val)}
          onCloseModal={() => setModalFilterCategoryProduct(false)}
        />
      </Modal>

      {/* Add Product by Sync URL */}
      <Modal size='xl' opened={modalAddProductUrl} onClose={() => setModalAddProductUrl(false)} title="Sync Product from URL">
        <FormAddProductUrl onCloseModal={() => setModalAddProductUrl(false)} reloadList={() => handleGetAllProduct()} />
      </Modal>

      {selectedBulkIds.length > 0 && (
        <Box
          pos="fixed"
          right={24}
          bottom={24}
          p="sm"
          bg="white"
          style={{
            border: '1px solid var(--mantine-color-gray-3)',
            borderRadius: 8,
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.14)',
            zIndex: 200,
          }}
        >
          <Group gap="sm">
            <Text size="sm" fw={500}>
              You have selected {selectedBulkIds.length} product{selectedBulkIds.length !== 1 ? 's' : ''} to edit
            </Text>
            <Button
              size="xs"
              color="blue"
              onClick={() => navigate(`/product/bulk-edit?ids=${selectedBulkIds.join(',')}`)}
            >
              Bulk Edit
            </Button>
          </Group>
        </Box>
      )}

    </AuthLayout>
  )
}

export default AllListProduct
